import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Bank: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <g opacity={1} fillRule="evenodd" clipRule="evenodd" fill={color}>
      <path d="M15.055 3.101a1.522 1.522 0 00-1.601-.017L2.822 9.515a1.015 1.015 0 00.525 1.883h1.521v11.67H3.44a.6.6 0 00-.6.6v.828a.6.6 0 00.6.6h21.12a.6.6 0 00.6-.6v-.83a.6.6 0 00-.6-.6h-1.43V11.4h1.522a1.015 1.015 0 00.544-1.873L15.056 3.101zm6.102 6.269l-6.922-4.387L6.983 9.37h14.174zm-6.144 2.03h6.088v11.666h-6.086L15.012 11.4zm-8.115 0v11.666h6.087V11.4H6.898z" />
    </g>
  </svg>
)
